import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=b579e52e&"
import script from "./UserChip.vue?vue&type=script&lang=js&"
export * from "./UserChip.vue?vue&type=script&lang=js&"
import style0 from "./UserChip.vue?vue&type=style&index=0&id=b579e52e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports